module.exports = require("eventsource");